/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { NetSuiteTransaction } from "./NetSuiteTransaction";
import {
  NetSuiteTransactionFromJSON,
  NetSuiteTransactionFromJSONTyped,
  NetSuiteTransactionToJSON,
  NetSuiteTransactionToJSONTyped,
} from "./NetSuiteTransaction";
import type { NetSuiteFulfillment } from "./NetSuiteFulfillment";
import {
  NetSuiteFulfillmentFromJSON,
  NetSuiteFulfillmentFromJSONTyped,
  NetSuiteFulfillmentToJSON,
  NetSuiteFulfillmentToJSONTyped,
} from "./NetSuiteFulfillment";

/**
 *
 * @export
 * @interface NetSuiteShipmentStatus
 */
export interface NetSuiteShipmentStatus {
  /**
   *
   * @type {string}
   * @memberof NetSuiteShipmentStatus
   */
  internalId?: string | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteShipmentStatus
   */
  fsId?: string | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteShipmentStatus
   */
  shipStatus?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof NetSuiteShipmentStatus
   */
  isCurrent?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteShipmentStatus
   */
  url?: string | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteShipmentStatus
   */
  bol?: string | null;
  /**
   *
   * @type {number}
   * @memberof NetSuiteShipmentStatus
   */
  cost?: number | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteShipmentStatus
   */
  sentAt?: string | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteShipmentStatus
   */
  lastWebhookAt?: string | null;
  /**
   *
   * @type {NetSuiteTransaction}
   * @memberof NetSuiteShipmentStatus
   */
  owner?: NetSuiteTransaction | null;
  /**
   *
   * @type {Array<NetSuiteFulfillment>}
   * @memberof NetSuiteShipmentStatus
   */
  fulfillments: Array<NetSuiteFulfillment>;
}

/**
 * Check if a given object implements the NetSuiteShipmentStatus interface.
 */
export function instanceOfNetSuiteShipmentStatus(
  value: object,
): value is NetSuiteShipmentStatus {
  if (!("fulfillments" in value) || value["fulfillments"] === undefined)
    return false;
  return true;
}

export function NetSuiteShipmentStatusFromJSON(
  json: any,
): NetSuiteShipmentStatus {
  return NetSuiteShipmentStatusFromJSONTyped(json, false);
}

export function NetSuiteShipmentStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): NetSuiteShipmentStatus {
  if (json == null) {
    return json;
  }
  return {
    internalId: json["internalId"] == null ? undefined : json["internalId"],
    fsId: json["fsId"] == null ? undefined : json["fsId"],
    shipStatus: json["shipStatus"] == null ? undefined : json["shipStatus"],
    isCurrent: json["isCurrent"] == null ? undefined : json["isCurrent"],
    url: json["url"] == null ? undefined : json["url"],
    bol: json["bol"] == null ? undefined : json["bol"],
    cost: json["cost"] == null ? undefined : json["cost"],
    sentAt: json["sentAt"] == null ? undefined : json["sentAt"],
    lastWebhookAt:
      json["lastWebhookAt"] == null ? undefined : json["lastWebhookAt"],
    owner:
      json["owner"] == null
        ? undefined
        : NetSuiteTransactionFromJSON(json["owner"]),
    fulfillments: (json["fulfillments"] as Array<any>).map(
      NetSuiteFulfillmentFromJSON,
    ),
  };
}

export function NetSuiteShipmentStatusToJSON(
  json: any,
): NetSuiteShipmentStatus {
  return NetSuiteShipmentStatusToJSONTyped(json, false);
}

export function NetSuiteShipmentStatusToJSONTyped(
  value?: NetSuiteShipmentStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    internalId: value["internalId"],
    fsId: value["fsId"],
    shipStatus: value["shipStatus"],
    isCurrent: value["isCurrent"],
    url: value["url"],
    bol: value["bol"],
    cost: value["cost"],
    sentAt: value["sentAt"],
    lastWebhookAt: value["lastWebhookAt"],
    owner: NetSuiteTransactionToJSON(value["owner"]),
    fulfillments: (value["fulfillments"] as Array<any>).map(
      NetSuiteFulfillmentToJSON,
    ),
  };
}
